import { convertISODate } from "@entrilia/shared/utilities/dateUtils";
import { Stack, Typography } from "@mui/material";
import type { AssistantTaskDetails } from "../../../../api/types/assistantTypes";
import { formatTaskTime } from "./taskStatus";

interface Props {
  details: AssistantTaskDetails;
}

interface FactProps {
  label: string;
  value: string;
}

const Fact = ({ label, value }: FactProps) => (
  <Stack spacing={0.25}>
    <Typography variant="caption" color="textSecondary">
      {label}
    </Typography>
    <Typography sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>{value}</Typography>
  </Stack>
);

const TaskFacts = ({ details }: Props) => {
  const { task, scheduleText, writeToolNames } = details;

  return (
    <Stack spacing={2}>
      <Fact label="What it does" value={task.instruction} />
      <Fact label="When" value={`${scheduleText} (${task.timeZoneId})`} />
      {task.schedule.endsOn && <Fact label="Ends" value={convertISODate(task.schedule.endsOn, "PP")} />}
      {task.nextRunAt && <Fact label="Next run" value={formatTaskTime(task.nextRunAt)} />}
      <Fact
        label="Without asking, may"
        value={writeToolNames.length > 0 ? writeToolNames.join(", ") : "Nothing — it only reads and reports"}
      />
    </Stack>
  );
};

export default TaskFacts;
